import { X } from "@untitledui/icons";
import { useChatAI } from "./chat-ai-context";
import { cx } from "@/utils/cx";
import { Tooltip } from "@/components/base/tooltip/tooltip";
import { useTranslation } from "react-i18next";
import { Tabs } from "@/components/application/tabs/tabs";

/**
 * Tabs per navigare tra chat recenti.
 */
export const ChatTabs = () => {
    const { chatTabs, activeChatId, switchChat, closeChatTab } = useChatAI();
    const { t } = useTranslation(["common"]);

    if (chatTabs.length === 0) return null;

    return (
        <div className="px-4 pb-2">
            <Tabs
                selectedKey={activeChatId || undefined}
                onSelectionChange={(key) => {
                    if (key) {
                        switchChat(key as string);
                    }
                }}
            >
                <Tabs.List
                    type="button-border"
                    size="sm"
                    items={chatTabs.map((tab) => ({
                        id: tab.id,
                        label: tab.title || t("aiChat.newChat"),
                    }))}
                >
                    {(item) => {
                        const tab = chatTabs.find((t) => t.id === item.id);
                        const isActive = activeChatId === item.id;
                        const title = tab?.title || t("aiChat.newChat");

                        return (
                            <Tabs.Item key={item.id} id={item.id}>
                                <div className="group flex items-center gap-2">
                                    <Tooltip title={title} placement="bottom">
                                        <span className="max-w-[180px] truncate">{item.label}</span>
                                    </Tooltip>
                                    {chatTabs.length > 1 && (
                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                closeChatTab(item.id as string);
                                            }}
                                            className={cx(
                                                "opacity-0 group-hover:opacity-100 rounded p-0.5 text-tertiary hover:bg-primary hover:text-primary transition",
                                                isActive && "opacity-100"
                                            )}
                                            aria-label={t("aiChat.closeTab", { defaultValue: "Close tab" })}
                                        >
                                            <X className="size-3" />
                                        </button>
                                    )}
                                </div>
                            </Tabs.Item>
                        );
                    }}
                </Tabs.List>
            </Tabs>
        </div>
    );
};
